import React from 'react';
import enhance from './CampaignNavBar.enhancer';
import Paper from '@material-ui/core/Paper';
import { div } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

class CampaignNavBar extends React.Component {
  constructor() {
    super();

    this.initialState = {};

    this.state = {
      ...this.initialState
    };
  }

  navigateToViewCampaign() {
    this.props.history.push(`/campaigns/${this.props.campaignId}/view`);
  }

  navigateToCampaignInvite() {
    this.props.history.push(`/campaigns/${this.props.campaignId}/invite`);
  }

  navigateToViewProposals() {
    this.props.history.push(`/campaigns/${this.props.campaignId}/proposals`);
  }

  navigateToViewDeals() {
    this.props.history.push(`/campaigns/${this.props.campaignId}/active`);
  }

  isProposalsCurrentPage(page) {
    if (page === 3 || page === 4 || page === 5 || page === 6) {
      return true;
    }
    return false;
  }

  isDealsCurrentPage(page) {
    if (page === 7 || page === 8 || page === 9) {
      return true;
    }
    return false;
  }

  render() {
    const { page, classes, campaign, allProposals, deals } = this.props;

    return (
      <React.Fragment>
        <div className={classes.headerContainer}>
          <Paper className={classes.workflowPaper}></Paper>
          <div className={classes.workflowContainer}>
            <div
              className={`${classes.workflowStart} ${classes.workflowItem} ${
                page === 1 ? classes.workflowItemSelected : ''
              }`}
              onClick={() => this.navigateToViewCampaign()}
            >
              <Typography justify="center" align="center">
                View Campaign
              </Typography>
            </div>
            <div
              className={`${classes.workflowMiddle} ${classes.workflowItem} ${
                page === 2 ? classes.workflowItemSelected : ''
              }`}
              onClick={() => this.navigateToCampaignInvite()}
            >
              <Typography justify="center" align="center">
                Invite Influencers
              </Typography>
            </div>
            <div
              className={`${classes.workflowMiddle} ${classes.workflowItem} ${
                this.isProposalsCurrentPage(page)
                  ? classes.workflowItemSelected
                  : ''
              }`}
              onClick={() => this.navigateToViewProposals()}
            >
              <Typography justify="center" align="center">
                Review Proposals{' '}
                {allProposals && allProposals.length >= 0
                  ? `(${allProposals.length})`
                  : ''}
              </Typography>
            </div>
            <div
              className={`${classes.workflowEnd} ${classes.workflowItem} ${
                this.isDealsCurrentPage(page)
                  ? classes.workflowItemSelected
                  : ''
              }`}
              onClick={() => this.navigateToViewDeals()}
            >
              <Typography justify="center" align="center">
                Deals {deals && deals.length >= 0 ? `(${deals.length})` : ''}
              </Typography>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default enhance(CampaignNavBar);



// WEBPACK FOOTER //
// ./src/components/campaign/CampaignNavBar.js